import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const SecurityAccessSimulatorGuidePage = () => <DataDrivenGuidePage slug="guide-security-access-simulator" />;

export default SecurityAccessSimulatorGuidePage;
